

































































import {
  getIresDeviceCategory,
  IresDevice,
  IresDeviceCategory,
} from "@/data/models/IresDevice";
import { Vue, Component, Model, Prop } from "vue-property-decorator";
import {
  ProgramChain,
  isOverviewProgramChain,
  isNewDryRunProgramChain,
} from "../../data/models/ProgramChain";

@Component
export default class DryingProgressGraphControlComponent extends Vue {
  @Prop() iresDevice!: IresDevice;
  @Prop() programChains!: Array<ProgramChain>;
  @Prop() selectedProgramChain!: ProgramChain;
  @Prop({ default: false }) showOverviewChainOption!: boolean;
  @Prop() selectedProgramChainDescription!: string;
  @Prop() showProgramChainDescriptionAsHeader!: string;

  @Model("selectedProgramChainIndexChanged")
  selectedProgramChainIndex!: number;

  /** Phones: the drying navigation buttons are small, the size of the view buttons (#2610011). */
  get isPhone() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  /** Phones and iPads (below 1264 px): short labels, and the parent's icons at the end of the line. */
  get isCompact() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  get showControlButtons() {
    return this.programChains.length > 1;
  }

  get showingOverviewProgramChain() {
    return isOverviewProgramChain(this.selectedProgramChain);
  }

  get showingNewDryingRunProgramChain() {
    return isNewDryRunProgramChain(this.selectedProgramChain);
  }

  get overviewChainButtonText() {
    if (this.showingOverviewProgramChain) {
      return this.$t(
        "panelDetail.dryingProgressGraphControl.single"
      ).toString();
    } else {
      return this.$t(
        "panelDetail.dryingProgressGraphControl.overview"
      ).toString();
    }
  }

  get iresDeviceCategory() {
    return getIresDeviceCategory(this.iresDevice);
  }

  get showPanelInfo() {
    return this.iresDeviceCategory === IresDeviceCategory.PANEL;
  }

  get showComBoxInfo() {
    return this.iresDeviceCategory === IresDeviceCategory.COMBOX;
  }

  get isSelectNextProgramChainDisabled() {
    return (
      this.showingOverviewProgramChain ||
      !(this.selectedProgramChainIndex >= 1 && this.programChains.length !== 0)
    );
  }

  get isSelectPreviousProgramChainDisabled() {
    return (
      this.showingOverviewProgramChain ||
      !(this.selectedProgramChainIndex < this.programChains.length - 1)
    );
  }

  onToggleOverviewProgramChain() {
    this.$emit("toggleOverviewProgramChain");
  }

  updateSelectedProgramChainIndex(update: number) {
    this.$emit("selectedProgramChainIndexChanged", update);
  }

  selectPreviousProgramChain() {
    this.updateSelectedProgramChainIndex(this.selectedProgramChainIndex + 1);
  }

  selectNextProgramChain() {
    this.updateSelectedProgramChainIndex(this.selectedProgramChainIndex - 1);
  }
}
